import { db } from '@/shared/services/firebase'
import { getUserById } from './userService'

const getReviews = async (areaId, action, mileStone) => {
  try {
    const PAGE_SIZE = 20

    let query = db.collection('reviews')
      .where('areaId', '==', areaId)
      .where('status', '==', 'submitted')
      .orderBy('date', 'desc')

    if (mileStone && action) {
      query = action === 'next' ? query.startAfter(mileStone) : query.endBefore(mileStone)
    }

    query = query.limit(PAGE_SIZE)

    const { docs } = await query.get()

    const reviews = await Promise.all(docs?.map(async doc => {
      const user = await getUserById(doc.data().userId)
      return {
        ...doc.data(),
        id: doc.id,
        user,
      }
    }))
  
    return reviews
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  // eslint-disable-next-line import/prefer-default-export
  getReviews,
}
